// app/page.tsx
"use client";

import { useState } from "react";
import { useRouter } from "next/navigation";
import { setToken } from "@/lib/auth";

export default function LoginPage() {
  const router = useRouter();

  const [account, setAccount] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  async function handleSubmit(
    e: React.FormEvent<HTMLFormElement>
  ) {
    e.preventDefault();

    setError("");

    try {
      const response = await fetch(
        `${process.env.NEXT_PUBLIC_API_URL}/auth`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            account,
            email,
            password,
          }),
        }
      );

      
      if (!response.ok) {
        throw new Error("Login failed");
      }

      const data = await response.json();

      setToken(data.token, data.expiresIn);

      router.push("/dashboard");
    } catch (err) {
      setError("Login failed");
    }
  }

  return (
    <main className="max-w-md mx-auto mt-20">
      <h1 className="text-3xl mb-6">
        Magic Photo Vault
      </h1>

      <form
        onSubmit={handleSubmit}
        className="space-y-4"
      >
        <input
          className="border p-2 w-full"
          placeholder="Account"
          value={account}
          onChange={(e) =>
            setAccount(e.target.value)
          }
        />

        <input
          className="border p-2 w-full"
          placeholder="Email"
          value={email}
          onChange={(e) =>
            setEmail(e.target.value)
          }
        />

        <input
          className="border p-2 w-full"
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) =>
            setPassword(e.target.value)
          }
        />

        <button
          type="submit"
          className="bg-blue-600 text-white px-4 py-2"
        >
          Login
        </button>

        {error && (
          <p className="text-red-600">
            {error}
          </p>
        )}
      </form>
    </main>
  );
}